(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('survey-response', {
            parent: 'entity',
            url: '/survey-response',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.surveyResponse.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/survey-response/survey-responses.html',
                    controller: 'SurveyResponseController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('surveyResponse');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('survey-response-detail', {
            parent: 'entity',
            url: '/survey-response/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.surveyResponse.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/survey-response/survey-response-detail.html',
                    controller: 'SurveyResponseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('surveyResponse');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SurveyResponse', function($stateParams, SurveyResponse) {
                    return SurveyResponse.get({id : $stateParams.id});
                }]
            }
        })
        .state('survey-response.new', {
            parent: 'survey-response',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/survey-response/survey-response-dialog.html',
                    controller: 'SurveyResponseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                answer: null,
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('survey-response', null, { reload: true });
                }, function() {
                    $state.go('survey-response');
                });
            }]
        })
        .state('survey-response.edit', {
            parent: 'survey-response',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/survey-response/survey-response-dialog.html',
                    controller: 'SurveyResponseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SurveyResponse', function(SurveyResponse) {
                            return SurveyResponse.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('survey-response', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('survey-response.delete', {
            parent: 'survey-response',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/survey-response/survey-response-delete-dialog.html',
                    controller: 'SurveyResponseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SurveyResponse', function(SurveyResponse) {
                            return SurveyResponse.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('survey-response', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
